import AddWidget, { Props as ImportedProps } from './AddWidget';
export default AddWidget;
export type Props = ImportedProps;
